import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { GateInInner } from "@/pages/GateInPage";
import { GateOutInner } from "@/pages/GateOutPage";
import { InternalDispatchInner } from "@/pages/InternalDispatchPage";
import { ArrowRight, ArrowLeft, Truck } from "@phosphor-icons/react";

export default function GerbangPage() {
  const [params, setParams] = useSearchParams();
  const initial = params.get("tab") === "out" ? "out" : params.get("tab") === "dispatch" ? "dispatch" : "in";
  const [tab, setTab] = useState(initial);

  const onChange = (v) => {
    setTab(v);
    setParams({ tab: v }, { replace: true });
  };

  return (
    <AppShell
      title="Manajemen Gerbang"
      subtitle="Catat kendaraan masuk & keluar dari satu halaman terpusat"
    >
      <Tabs value={tab} onValueChange={onChange}>
        <TabsList className="mb-6 bg-white border border-slate-200 p-1 rounded-lg shadow-sm h-auto">
          <TabsTrigger
            value="in"
            data-testid="gerbang-tab-in"
            className="gap-2 data-[state=active]:bg-sky-600 data-[state=active]:text-white px-5 py-2 rounded-md text-sm font-semibold"
          >
            <ArrowRight size={16} weight="bold" /> Gerbang Masuk
          </TabsTrigger>
          <TabsTrigger
            value="out"
            data-testid="gerbang-tab-out"
            className="gap-2 data-[state=active]:bg-slate-900 data-[state=active]:text-white px-5 py-2 rounded-md text-sm font-semibold"
          >
            <ArrowLeft size={16} weight="bold" /> Gerbang Keluar
          </TabsTrigger>
          <TabsTrigger
            value="dispatch"
            data-testid="gerbang-tab-dispatch"
            className="gap-2 data-[state=active]:bg-amber-600 data-[state=active]:text-white px-5 py-2 rounded-md text-sm font-semibold"
          >
            <Truck size={16} weight="bold" /> Truk Internal
          </TabsTrigger>
        </TabsList>

        <TabsContent value="in" className="mt-0">
          <GateInInner />
        </TabsContent>
        <TabsContent value="out" className="mt-0">
          <GateOutInner />
        </TabsContent>
        <TabsContent value="dispatch" className="mt-0">
          <InternalDispatchInner />
        </TabsContent>
      </Tabs>
    </AppShell>
  );
}
